<h1 mat-dialog-title class="no-margin">ASSOCIA CLASSIFICAZIONI<mat-icon class="close-icon"
                                                                        (click)="onNoClick()">close</mat-icon></h1>
<h1 class="istruzioni" *ngIf="data.permission">Per associare le classificazioni trascinale nella lista "classificazioni
  associate"
</h1>
<mat-tab-group (selectedTabChange)="onTabChanged($event);">
  <mat-tab label="{{label}}" *ngFor="let label of labels">
    <div class="dialog-body-overflow">
      <div cdkDropListGroup>
        <div class="associazione-competenze-container" *ngIf="data.permission">
          <mat-accordion *ngIf="(label == 'ADA' || label == 'ATECO')">

            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h3><mat-icon class="green"
                                style="position: relative; bottom: -5px; margin-right:5px;">menu</mat-icon>Ricerca
                    per area</h3>
                </mat-panel-title>

              </mat-expansion-panel-header>
              <mat-form-field class="full-width margin-bottom-10">
                <mat-select [(ngModel)]="area" name="area" placeholder="Seleziona area"
                            (selectionChange)="filterArea($event)">
                  <mat-option *ngFor="let item of aree" [value]="item">
                    {{item.descrizione}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width margin-bottom-10" *ngIf="(label == 'ATECO') && area">
                <mat-select [(ngModel)]="sottoarea" name="sottoarea" placeholder="Seleziona sottoarea"
                            (selectionChange)="filterSottoArea($event)">
                  <mat-option *ngFor="let item of sottoaree" [value]="item">
                    {{item.descrizione}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width margin-bottom-10"
                              *ngIf="(label == 'ADA' && listaProcessi)">
                <mat-select [(ngModel)]="processo" name="processi" placeholder="Seleziona processo"
                            (selectionChange)="filterProcessi($event,processo)">
                  <mat-option *ngFor="let item of listaProcessi" [value]="item">
                    {{item.descrizione}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width margin-bottom-10"
                              *ngIf="(label == 'ADA' && listaSequenze)">
                <mat-select [(ngModel)]="sequenza" name="sequenze" placeholder="Seleziona sequenza"
                            (selectionChange)="filterSequenze($event)">
                  <mat-option *ngFor="let item of listaSequenze" [value]="item">
                    {{item.descrizione}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-expansion-panel>
            <!-- <mat-form-field class="full-width" *ngIf="(label == 'ISTAT' || label == 'ISCO')">
                <mat-label>Ricerca {{label}} per Cod/Desc</mat-label>
                <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
                <mat-icon class="search">search</mat-icon>
            </mat-form-field> -->
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h3><mat-icon class="green"
                                style="position: relative; bottom: -5px; margin-right:5px;">menu</mat-icon>Ricerca
                    {{label}} per Cod/Desc</h3>
                </mat-panel-title>

              </mat-expansion-panel-header>
              <mat-form-field class="full-width" *ngIf="(label == 'ADA' || label == 'ATECO')">
                <mat-label>Ricerca {{label}} per Cod/Desc</mat-label>
                <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
                <button [disabled]="!searchText" *ngIf="(label == 'ADA' || label == 'ATECO')" mat-fab
                        extended class="search_button custom-button searchbox-buttons save-button"
                        (click)="searchByString(searchText)">
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>

            </mat-expansion-panel>



          </mat-accordion>
          <div style="display:block; height:15px;" *ngIf="(label == 'ADA' || label == 'ATECO')"></div>
          <div style="display:block; height:88px;" *ngIf="(label == 'ISTAT' || label == 'ISCO')">
            <mat-form-field class="full-width" *ngIf="(label == 'ISTAT' || label == 'ISCO')">
              <mat-label>Ricerca {{label}} per Cod/Desc</mat-label>
              <input [(ngModel)]="searchText" matInput placeholder="Ricerca">
              <button [disabled]="!searchText" *ngIf="(label == 'ISTAT' || label == 'ISCO')" mat-fab
                      extended class="search_button custom-button searchbox-buttons save-button"
                      (click)="filterList(searchText)">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
            <!-- <button [disabled]="!searchText" *ngIf="(label == 'ISTAT' || label == 'ISCO')" mat-fab extended
                class="custom-button searchbox-buttons save-button" (click)="filterList(searchText)">
                <mat-icon>search</mat-icon>Cerca
            </button> -->
          </div>
          <div cdkDropList [cdkDropListData]="filteredLista" class="competenze-list" id="listaCompetenze"
               (cdkDropListDropped)="drop($event)">
            <div class="competenze-box" *ngFor="let item of filteredLista" cdkDrag>
              <!-- <div class="icon-container">
                  <mat-icon class="pointer" (click)="competenzaDetail(item)"
                      matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>

              </div> -->

              <p style="display:block; width:100%;">
                <span *ngIf="item.codiceAda" class="primary-details">{{item.codiceAda}} - </span>
                <span *ngIf="item.codiceAteco" class="primary-details">{{item.codiceAteco}} - </span>
                <span *ngIf="item.codiceIsco" class="primary-details">{{item.codiceIsco}} - </span>
                <span *ngIf="item.codiceIstat" class="primary-details">{{item.codiceIstat}} - </span>
                <span *ngIf="!item.codiceIstat" class="secondary-details">{{item.descrizione}}</span>
                <span *ngIf="item.codiceIstat" class="secondary-details">{{item.nome}}</span>
              </p>




            </div>
          </div>
          <mat-paginator #paginator [pageSize]="10" [length]="pageLength" [pageIndex]="0" showFirstLastButtons
                         (page)="onPaginateChange($event)"></mat-paginator>
        </div>

        <div class="associazione-competenze-container" [ngClass]="{'fullWidth':!data.permission}">
          <!-- <h2 class="subtitle_associate">Classificazioni associate</h2> -->
          <mat-form-field class="full-width margin-bottom-10">
            <mat-label>Ricerca class. associate {{label}}</mat-label>
            <input [(ngModel)]="searchTextAssociate" matInput placeholder="Ricerca"
                   (input)="filterListAssociate($event)">
            <mat-icon class="search">search</mat-icon>
          </mat-form-field>
          <div cdkDropList [cdkDropListData]="filteredListaAssociate" class="competenze-list"
               id="competenzeAssociate" (cdkDropListDropped)="drop($event)">
            <div class="competenze-box" *ngFor="let item of filteredListaAssociate"
                 (cdkDragStarted)="dragItem(item)" cdkDrag>
              <!-- <div class="icon-container">
                  <mat-icon class="pointer" (click)="competenzaDetail(item)"
                      matTooltip="Dettaglio competenza">remove_red_eye</mat-icon>

              </div> -->
              <p style="display:block; width:100%;">
                <span *ngIf="item.codiceAda" class="primary-details">{{item.codiceAda}} - </span>
                <span *ngIf="item.codiceAteco" class="primary-details">{{item.codiceAteco}} - </span>
                <span *ngIf="item.codiceIsco" class="primary-details">{{item.codiceIsco}} - </span>
                <span *ngIf="item.codiceIstat" class="primary-details">{{item.codiceIstat}} - </span>
                <span *ngIf="!item.codiceIstat" class="secondary-details">{{item.descrizione}}</span>
                <span *ngIf="item.codiceIstat" class="secondary-details">{{item.nome}}</span>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>

  </mat-tab>

</mat-tab-group>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" [disabled]="!data.permission"
          (click)="associaClassificazioni(filteredListaAssociate)">
    <mat-icon>compare_arrows</mat-icon>Salva
  </button>
</div>
<!-- <div class="loading" *ngIf="filteredLista">
<mat-spinner></mat-spinner>
</div> -->
